type CircleType = {
  size?: number;
  stroke?: string;
  fill?: string;
  opacity?: number;
};

const Circle = ({
  size = 10,
  stroke = "#000",
  fill = "#FFF",
  opacity = 1,
}: CircleType) => (
  <svg
    data-testid="Circle-svg"
    width={size}
    height={size}
    style={{ display: "block", verticalAlign: "middle" }}
  >
    <circle
      data-testid="Circle-svg-circle"
      cx={size / 2}
      cy={size / 2}
      r={size / 2.5}
      stroke={stroke}
      strokeWidth="0.5"
      fill={fill}
      opacity={opacity}
    />
  </svg>
);

export default Circle;
